"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _TitleState = _interopRequireDefault(require("../../../title-actions/TitleState"));

var _MediaInterface = _interopRequireDefault(require("../MediaInterface"));

var _assetMapper = require("../../../../../lib/assetMapper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Title =
/*#__PURE__*/
function (_Backbone$Model) {
  _inherits(Title, _Backbone$Model);

  _createClass(Title, [{
    key: "defaults",
    value: function defaults() {
      return {
        id: 0,
        firstCreatorName: 'Author',
        title: 'Title',
        firstCreatorId: 0,
        formats: [],
        isOwned: false,
        isHoldable: false,
        isRecommendableToLibrary: false,
        isPreReleaseTitle: false,
        isAvailable: false,
        starRating: 0.0,
        userStarRating: 0,
        starRatingCount: 0,
        holdsRatio: 0,
        holdsCount: 0,
        ownedCopies: 0,
        availableCopies: 0,
        luckyDayOwnedCopies: 0,
        luckyDayAvailableCopies: 0,
        estimatedReleaseDate: '',
        availabilityType: '',
        description: '',
        sample: {},
        // Sample
        publisher: {},
        // Publisher
        type: {
          id: 'ebook'
        },
        // Type
        covers: {},
        // Covers
        // Custom Lightning Properties
        titleState: 'waiting',
        isRecommended: false,
        wishlistState: 'wishlistAdd',
        isInHistory: false,
        addToAppFormat: null,
        isOnHold: false,
        isReleasedHold: false,
        isBorrowed: false
      };
    }
  }, {
    key: "setContext",
    value: function setContext(context) {
      this.context = context;
    }
  }, {
    key: "idAttribute",
    get: function get() {
      return 'id';
    }
  }, {
    key: "isPlaceholder",
    get: function get() {
      return this.get('placeholder');
    }
  }]);

  function Title(model, options, context) {
    var _this;

    _classCallCheck(this, Title);

    var _ref = options || {},
        patronItems = _ref.patronItems;

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Title).call(this, model, options));

    _this.setContext(context);

    _this.set(_.extend({}, model, {
      titleState: _this._getState(patronItems)
    }));

    if (!_this.isPlaceholder) {
      _this.link(window.globalEvents);
    }

    return _this;
  }

  _createClass(Title, [{
    key: "link",
    value: function link(bus) {
      var _this2 = this;

      // Unlink the old bus if there is one
      if (this.bus) {
        this.stopListening(this.bus, 'title:update');
        this.bus = null;
      } // Attach new bus if passed


      if (bus) {
        this.bus = bus;
        this.listenTo(this.bus, 'title:update', function (titleModel) {
          _this2._applyUpdates(titleModel);
        });
      }

      return this;
    }
  }, {
    key: "_applyUpdates",
    value: function _applyUpdates(titleModel) {
      if (titleModel !== this && titleModel.id === this.id) {
        _get(_getPrototypeOf(Title.prototype), "set", this).call(this, titleModel.changedAttributes());
      }
    }
  }, {
    key: "set",
    value: function set() {
      _get(_getPrototypeOf(Title.prototype), "set", this).apply(this, arguments);

      this.bus && this.bus.trigger('title:update', this);
    } // An example of this can be seen in CollectionHightlight.js:61 (where TitleCollectionView gets new'ed up)

  }, {
    key: "updatePatronState",
    value: function updatePatronState(patronItems) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.set({
        titleState: this._getState(patronItems),
        wishlistState: _TitleState["default"].isOnWishlist(this.attributes, patronItems) ? 'wishlistRemove' : 'wishlistAdd',
        userStarRating: _TitleState["default"].starRating(this.attributes, patronItems) // 0 if not rated

      }, options);

      var readingHistoryState = _TitleState["default"].isOnReadingHistory(this.attributes, patronItems);

      this.set('isInHistory', readingHistoryState, options || {});

      var userStarRating = _TitleState["default"].starRating(this.attributes, patronItems);

      this.set('userStarRating', userStarRating, options || {}); // 0 if not rated
    }
  }, {
    key: "getCover",
    value: function getCover(desiredSize) {
      var covers = _.map(this.get('covers'), function (cover) {
        return cover;
      }); // maps to collection of covers


      var coversBySize = _.sortBy(covers, 'width'); // coversBySize is now an array of covers, from smallest to largest
      // Start with the biggest cover
      // Copy object with Object.assign() so we dont damage reference


      var optimizedCover = Object.assign({}, _.last(covers)); // if this image opto stuff catches on we'll figure out a way
      // to get cleaner image urls, which will make this all much
      // simpler

      if (optimizedCover && optimizedCover.href) {
        var legacyImageHost = 'https://img1.od-cdn.com/';
        var optimizedImageHost = 'https://ic.od-cdn.com/';
        var optimizedUrl = optimizedCover.href.replace(legacyImageHost, optimizedImageHost); // format=auto -> use webp if the device supports it

        var optimizations = 'quality=80&w=' + desiredSize;
        var queryString = (optimizedUrl.indexOf('?') < 0 ? '?' : '&') + optimizations;
        optimizedCover.href = optimizedUrl + queryString;
        return optimizedCover;
      }

      var smallestCoverThatIsBigEnough = _.find(coversBySize, function (cover) {
        return cover.width >= desiredSize;
      }) || _.last(covers); // finds the first cover that is big enough


      return smallestCoverThatIsBigEnough;
    }
  }, {
    key: "getCoverSrc",
    value: function getCoverSrc(desiredSize) {
      var cover = this.getCover(desiredSize);
      return cover && cover.href || (0, _assetMapper.toStaticUrl)('img/no-cover_en_US.jpg');
    }
  }, {
    key: "getCurrentAvailability",
    value: function getCurrentAvailability() {
      return $.ajax({
        url: window.url(window.routes.mediaAvailabilityId, {
          id: this.id
        }),
        type: 'GET',
        timeout: 0
      });
    }
  }, {
    key: "getMissingAttribute",
    value: function getMissingAttribute(attribute) {
      var _this3 = this;

      if (!this._mediaInterface) {
        this._mediaInterface = new _MediaInterface["default"]();
      }

      return this._mediaInterface.search({
        titleId: this.get('id')
      }).then(function (response) {
        _this3.set(attribute, response[attribute]);

        return Promise.resolve();
      });
    }
  }, {
    key: "availabilityText",
    value: function availabilityText() {
      var action = this.get('titleState');
      var availabilityText = '';

      switch (action) {
        case 'recommend':
          availabilityText = window.html('availabilityNotOwned');
          break;

        case 'recommended':
          availabilityText = window.html('recommended');
          break;

        case 'unavailable':
          availabilityText = window.html('availabilityUnavailable');
          break;

        case 'nook':
          availabilityText = window.html('availabilityAvailable');
          break;

        case 'borrow' || 'preview':
          availabilityText = window.html('availabilityAvailable');
          break;

        case 'borrowed':
        case 'addToApp':
        case 'listenNow':
        case 'readNow':
          availabilityText = window.html('borrowed');
          break;

        case 'hold':
          if (this.get('isPreReleaseTitle')) {
            availabilityText = window.html('availabilityComingSoon');
            break;
          }

          availabilityText = this.get('isPreReleaseTitle') ? window.html('availabilityComingSoon') : window.html('availabilityWaitList');
          break;

        case 'onHold':
          availabilityText = window.html('onHold');
          break;

        case 'waiting':
          availabilityText = window.html('loading');
          break;
      }

      return availabilityText;
    }
  }, {
    key: "_getState",
    value: function _getState(patronItems) {
      this.setPatronState(patronItems);
      return _TitleState["default"].getState(this.attributes, patronItems);
    }
  }, {
    key: "setPatronState",
    value: function setPatronState(patronItems) {
      this.set({
        isOnHold: patronItems && patronItems.onHolds.indexOf(this.id) > -1
      });
      this.set({
        isBorrowed: patronItems && patronItems.onCheckouts.indexOf(this.id) > -1
      });
      this.set({
        isRecommended: patronItems && patronItems.recommendedToLibrary.indexOf(this.id) > -1
      });
    }
  }, {
    key: "sanitizedDesc",
    value: function sanitizedDesc() {
      var desc = this.get('description').replace(/(<br\s*[\/]?>)|(\r?\n|\r)/gim, ' ');
      return $("<div>".concat(desc, "</div>")).text();
    }
  }, {
    key: "getTitleAsync",
    value: function getTitleAsync(mediaId, resolve, reject) {
      var _this4 = this;

      $.ajax({
        url: window.url(window.routes.mediaInfoId, {
          id: mediaId
        }),
        type: 'GET',
        timeout: 10000,
        success: function success(data) {
          _this4.set(data);

          _this4.set('titleState', _this4._getState(null));

          resolve();
        },
        fail: function fail(err) {
          reject(err);
        }
      });
    }
  }, {
    key: "contextCollectionId",
    get: function get() {
      return this.context && this.context.collectionDefinition ? this.context.collectionDefinition.id : undefined;
    }
  }, {
    key: "titleDetailsUrl",
    get: function get() {
      // LHTNG-3018 Reference optional contextCollectionId value when creating a title details link
      var props = {
        id: this.id
      };

      if (this.contextCollectionId) {
        props.cid = this.contextCollectionId;
      }

      return window.url(window.routes.mediaId, props);
    }
  }, {
    key: "hasLuckyDayCopies",
    get: function get() {
      return window.featureManager.isEnabled('LuckyDay') && this.get('luckyDayOwnedCopies') > 0;
    }
  }, {
    key: "allCopiesAreLuckyDay",
    get: function get() {
      return this.hasLuckyDayCopies && this.get('ownedCopies') === 0;
    }
  }, {
    key: "isLuckyDayCheckout",
    get: function get() {
      return this.hasAvailableLuckyDayCopies && this.get('availableCopies') === 0 && !this.get('isReleasedHold');
    }
  }, {
    key: "canPlaceHold",
    get: function get() {
      return this.get('isHoldable') && !this.get('isOnHold') && window.featureManager.isEnabled('content-holds');
    }
  }, {
    key: "isAvailable",
    get: function get() {
      return this.get('isAvailable') || this.hasAvailableLuckyDayCopies;
    }
  }, {
    key: "hasAvailableLuckyDayCopies",
    get: function get() {
      return this.hasLuckyDayCopies && this.get('luckyDayAvailableCopies') > 0;
    }
  }, {
    key: "isMagazine",
    get: function get() {
      return this.get('type').id === 'magazine';
    }
  }]);

  return Title;
}(Backbone.Model);

exports["default"] = Title;